document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-menu]');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      nav.classList.toggle('is-open', !isOpen);
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', (event) => {
      const form = event.target.closest('form');
      const button = form?.querySelector('[data-add-to-cart]');
      const option = event.target.options[event.target.selectedIndex];
      if (button && option) {
        button.disabled = option.dataset.available !== 'true';
        button.textContent = option.dataset.available === 'true' ? 'Add to bag' : 'Sold out';
      }
    });
  });
});
